import { createFileRoute } from '@tanstack/react-router'
import { ResetPasswordPage } from '~/features/auth/PasswordPages'

export const Route = createFileRoute('/passwort-neu')({
  validateSearch: (s: Record<string, unknown>): { token?: string } =>
    typeof s.token === 'string' && /^[\w-]{10,200}$/.test(s.token) ? { token: s.token } : {},
  component: function ResetPassword() {
    return <ResetPasswordPage token={Route.useSearch().token} />
  },
})
